// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field } from 'redux-form';
const CertificationSection = () => (
    <div className="form_section">
        <div className="modal_title">Part II: Certification</div>
        <div className="modal_subtitle certification_modal__legal-text">
            <p>Under penalties of perjury, I certify that:</p>
            <p>1. The number shown on this form is my correct taxpayer identification number (or I am waiting for a
                number to be issued to me), and</p>
            <p>2. I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I
                have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding
                as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I
                am no longer subject to backup withholding, and</p>
            <p>3. I am a US citizen or other US. person (defined below).</p>
        </div>
        <div className="certification_modal__check-row">
            <label className="wo-check-btn check_btn">
                <Field name="isTaxInfoCorrect" component="input" type="checkbox"/>
                <span className="certification_modal__check-label">I certify that the above tax information is correct</span>
            </label>
        </div>
    </div>
);

export default CertificationSection;
